import { render, staticRenderFns } from "./InputBoolean.vue?vue&type=template&id=56a314f8&scoped=true&"
import script from "./InputBoolean.vue?vue&type=script&lang=ts&"
export * from "./InputBoolean.vue?vue&type=script&lang=ts&"
import style0 from "./InputBoolean.vue?vue&type=style&index=0&id=56a314f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a314f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
